class MktoCountryStateManager {
    constructor(apiUrl, form, defaultLang = "en") {
      this._apiUrl = apiUrl;
      this.form = form;
      this.defaultLang = defaultLang;
      this.mktoCountries = null;
      this.countrySelect = this.form.querySelector("#Country");
      
      if (this.countrySelect && this.countrySelect.options.length <= 1) {
        this.init();
      }
    }
  
    async init() {
      await this.loadCountries();
      if (!this.shouldUpdateCountrySelect()) {
        return;
      }
      this.MktoCountryStateConditional();
    }
  
    async loadCountries() {
      try {
        const response = await fetch(`${this._apiUrl}index.php`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        this.mktoCountries = await response.json();
        console.log("mktoCountries", this.mktoCountries);
      } catch (error) {
        console.error("Failed to load countries", error);
      }
    }
  
    clearOptions(select) {
      while (select.options && select.options.length > 1) {
        select.options[1].remove();
      }
    }
  
    createOptionElement(key, value) {
      const option = document.createElement("option");
      option.value = key;
      option.textContent = value;
      return option;
    }

    shouldUpdateCountrySelect() {
      return Array.from(this.countrySelect.options).some(option => this.mktoCountries && this.mktoCountries[option.value]) === false;
    }
  
    MktoCountryStateConditional() {
        const siteEl = document.head.querySelector("meta[name=form_language][value]") || document.querySelector("html").getAttribute("lang")?.substring(0, 2);
      let formLang = siteEl ? siteEl : this.defaultLang;
  
        this.clearOptions(this.countrySelect);

        const sortedCountries = Object.entries(this.mktoCountries).sort((a, b) => {
          const countryAName = a[1].translations[formLang] || a[1].translations[this.defaultLang];
          const countryBName = b[1].translations[formLang] || b[1].translations[this.defaultLang];
          return countryAName.localeCompare(countryBName, formLang);
        });
  
        for (const [key, value] of sortedCountries) {
            this.countrySelect.appendChild(
            this.createOptionElement(
              key,
              value.translations[formLang] || value.translations[this.defaultLang]
            )
          );
        }
  
        const stateSelect = this.form.querySelector("#State");
        const postalInput = this.form.querySelector("#PostalCode");
  
        if (stateSelect) {
          stateSelect.parentElement.parentElement.style.display = "none";
          postalInput.parentElement.parentElement.style.display = "none";
          postalInput.parentElement.parentElement.classList.remove("mktoFieldDescriptor");
          stateSelect.options[0].value = "NULL";
  
          this.countrySelect.addEventListener("change", (e) => {
            const country = this.mktoCountries[e.target.value];
            if (country?.use_postal) {
              postalInput.parentElement.parentElement.style.display = "block";
              postalInput.parentElement.parentElement.classList.add("mktoFieldDescriptor");
            } else {
              postalInput.parentElement.parentElement.style.display = "none";
              postalInput.parentElement.parentElement.classList.remove("mktoFieldDescriptor");
            }
          });
        }
    }
  }
  
export default MktoCountryStateManager;
  